let setter = null;

/**
 * Subscribe popup changes
 * @param {Function} onDataChange
 */
const subscribe = (onDataChange) => {
    setter = onDataChange;
};

/**
 * Unsubscribe popup changes
 */
const unsubscribe = () => {
    setter = null;
};

/**
 * Set popup
 * @param {Array} data - Popup data
 * @param {(Object|Function)} data.instance - Component instance
 * @param {Object} data.optionalProps - Optional props
 * @param {Object} data.optionalListeners - Optional listeners
 */
const set = (data) => {
    if (setter) {
        setter(data);
    }
};

/**
 * Remove popup
 */
const remove = () => {
    if (setter) {
        setter({});
    }
};

export default function (ignore, inject) {
    inject('popup', {
        subscribe,
        unsubscribe,
        set,
        remove,
    });
}
